import React from 'react';
import { AuthProvider } from './Context/AuthContext';
import Routers from './Routes';

function App() {
  return (
    <AuthProvider>
      <Routers/>
    </AuthProvider>
  );
}

export default App;
